import { isBefore, isAfter, addHours } from "date-fns";
import CONSTANTS from "core/constants";
import { SlotApiRes, Template, TemplateNames } from "core/types";

// TODO: can we remove this completely? It seems to be handled (better) in the api.
// But there must be a reason it was implemented 4 months ago
export const isSlotOverlapping = (
  slots: SlotApiRes[],
  templates: Template[],
  slotToCheck: Pick<
    SlotApiRes,
    "startsAt" | "endsAt" | "templateId" | "method"
  >,
) => {
  const slotToAddTemplateData =
    templates?.find((x) => x.templateId === slotToCheck.templateId) ??
    templates.find((x) => x.name === CONSTANTS.NEW_VISIT);

  const shouldAddNewSlot = slots.every((slotItem) => {
    const slotTemplateData = templates.find(
      (x) => x.templateId === slotItem.templateId,
    );

    if (slotTemplateData?.allowParallel) {
      return true;
    }

    const isOverlapAllowed =
      slotTemplateData?.name === TemplateNames.work_hours ||
      slotToAddTemplateData?.name === TemplateNames.work_hours ||
      slotItem.status === CONSTANTS.BOOKING_STATUS.CANCELED;

    const isOverLapping =
      new Date(slotItem?.startsAt ?? 0).getTime() <
        new Date(slotToCheck.endsAt).getTime() &&
      new Date(slotItem.endsAt).getTime() >
        new Date(slotToCheck.startsAt).getTime();

    if (!isOverlapAllowed && isOverLapping) {
      return false;
    }

    return true;
  });

  return shouldAddNewSlot;
};

export const isSlotInThePast = (
  slotStart: Date | number | string,
  selectedTemplate: Template,
) =>
  isBefore(new Date(slotStart), new Date()) && !selectedTemplate?.allowInPast;

export const isSlotWithinTwoHours = (slotStart: Date | number | string) => {
  const now = new Date();
  const twoHoursFromNow = addHours(now, 2);

  return (
    isBefore(now, new Date(slotStart)) &&
    isAfter(twoHoursFromNow, new Date(slotStart))
  );
};
